import store from '~/store'

export function config (param) {
  return store.getters['config/get'](param)
}

export function hasCasinoGamesEnabled(){
  return hasUserCasinoGamesEnabled() && isGlobalCasinoGamesEnabled()
}
export function hasLotteryEnabled(){
  return hasUserGlobalLotteryEnabled() && isGlobalLotteryEnabled()
}
export function hasSportsBetEnabled(){
  return hasUserGlobalSportsBetEnabled() && isGlobalSportsBetEnabled()
}

export function isGlobalCasinoGamesEnabled(){
  return config('app.enable_casino_games')
}
export function isGlobalLotteryEnabled(){
  return config('app.enable_lottery')
}
export function isGlobalSportsBetEnabled(){
  return config('app.enable_sports_bet')
}

export function hasUserCasinoGamesEnabled(){
  return store.state?.auth?.user?.enable_casino_games
}
export function hasUserGlobalLotteryEnabled(){
  return store.state?.auth?.user?.enable_lottery
}
export function hasUserGlobalSportsBetEnabled(){
  return store.state?.auth?.user?.enable_sports_bet
}

export function isPos(){
  return config('app.is_pos')
}